module.exports = __webpack_public_path__ + "static/3-5be0886e7272f667ecbfd1094f63347a.jpg";